import React from "react";
import "./Nav.style.scss";

const Nav = ({ triggerCallBack, selectedTab, disableTab }) => {
  let callBack = () => {
    if (selectedTab === "assetAllocationFunds") {
      document.getElementById("aaf").click();
    } else if (selectedTab === "modelPortfolios") {
      document.getElementById("mp").click();
    } else {
      document.getElementById("bap").click();
    }
  };

  if (triggerCallBack) {
    setTimeout(() => callBack(), 0);
  }
  return (
    <div className="buildPortfolio__heading">
      <ul className="nav nav-tabs">
        <li className="active">
          <a
            href="#cpa_1"
            data-toggle="tab"
            id="bap"
            className={
              selectedTab !== "customPortfolio" &&
              selectedTab !== "managerSelection" &&
              disableTab
                ? "disabled"
                : ""
            }
          >
            Build a portfolio
          </a>
        </li>
        <li>
          <a
            href="#cpa_2"
            data-toggle="tab"
            id="aaf"
            className={
              selectedTab !== "assetAllocationFunds" && disableTab
                ? "disabled"
                : ""
            }
          >
            Asset allocation funds
          </a>
        </li>
        <li>
          <a
            href="#cpa_3"
            data-toggle="tab"
            id="mp"
            className={
              selectedTab !== "modelPortfolios" && disableTab ? "disabled" : ""
            }
          >
            Model portfolios
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/common/nav/Nav.jsx